export * from "./bizzBuzz";
export * from "./greet";
export * from "./primeFactors";
export * from "./recentlyList";

export const dump = [
  {
    title: "test1",
    code: `expect(test(1)).toBe('');`,
    outcome: null,
  },
  {
    title: "test1",
    code: `expect(test(1)).toBe('');`,
    outcome: null,
  },
];

export const createMyOwn = [
  // {
  //   title: "test1",
  //   code: `expect(test(1)).toBe('');`,
  //   outcome: null,
  //   isAdded: true,
  // },
];
